import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(Item(), {
    state() {
        return {
            id: null,
            impersonator_id: null,
            impersonated_user_id: null,
            impersonator: null,
            impersonated_user: null,
            session_id: null,
            started_at: null,
            ended_at: null,
            actions_count: 0,
            ip_address: null,
            user_agent: null,
            created_at: null,
            updated_at: null,
        };
    },

    getters: {
        id: state => state.id,
    },
});
